import React, { useMemo } from 'react';

import {
  DescriptionList,
  DescriptionItem,
  Typography,
  Grid,
  makeStyles,
  Divider,
  Button,
  NoResults,
} from '@gogame/components';

import Status from 'scenes/PlayersActivities/components/Status';

import { TYPE_DATE, TYPE_STATUS } from './constants';

const useStyles = makeStyles((theme) => ({
  root: {
    height: '100%',
    width: '100%',
  },
  emptyStateTypography: {
    color: theme.palette.text.secondary,
  },
  divider: {
    padding: '16px 0',
  },
  message: {
    marginBottom: '8px',
  },
}));

export const renderDescriptionList = (record) => {
  return (
    <DescriptionList
      data={record}
      disableGutters={true}
      stripEmpty={true}
      termWidth={'30%'}
    >
      {record.items.map(({ title, value, type }, itemIndex) => {
        switch (type) {
          case TYPE_STATUS:
            return (
              <DescriptionItem
                label={title}
                type={'status'}
                value={{ id: value }}
                key={itemIndex}
                statusFactory={Status}
              />
            );
          case TYPE_DATE:
            return (
              <DescriptionItem
                label={title}
                type={'date'}
                template={'LLLL'}
                timeZone={'local'}
                value={value}
                key={itemIndex}
              />
            );
          default:
            return (
              <DescriptionItem label={title} value={value} key={itemIndex} />
            );
        }
      })}
    </DescriptionList>
  );
};

const Results = ({ data, isLoading, onEdit }) => {
  const classes = useStyles();
  const isShowEmptyState = useMemo(
    () => !data && !isLoading,
    [data, isLoading]
  );

  const isShowMessage = useMemo(() => !!data?.message, [data?.message]);
  const isShowResults = useMemo(() => !!data?.results?.length, [data?.results]);

  return (
    <Grid container className={`${isShowEmptyState ? classes.root : ''}`}>
      {isShowEmptyState && (
        <Grid item container alignItems={'center'} justifyContent={'center'}>
          <NoResults
            inited={true}
            noResultsLabel={`Press the "Apply" Button to view results`}
          />
        </Grid>
      )}

      {isShowMessage && (
        <Grid item xs={12} className={classes.message}>
          <Typography variant={'subtitle2'}>{data?.message}</Typography>
        </Grid>
      )}

      {isShowResults && (
        <Grid item xs={12} className={classes.message}>
          <Typography variant={'subtitle1'}>Results</Typography>
        </Grid>
      )}

      {data?.results?.map((record, recordIndex) => (
        <Grid item container key={recordIndex}>
          <Grid item container alignItems={'center'} spacing={2} xs={12}>
            <Grid item>
              <Typography variant={'subtitle2'}>{record?.title}</Typography>
            </Grid>
            {onEdit && (
              <Grid item>
                <Button variant={'outlined'} onClick={() => onEdit(record)}>
                  Edit last session date
                </Button>
              </Grid>
            )}
          </Grid>
          <Grid item xs={12} className={classes.divider}>
            <Divider />
          </Grid>
          <Grid item xs={6}>
            {renderDescriptionList(record)}
          </Grid>
        </Grid>
      ))}
    </Grid>
  );
};

export default Results;
